import { MiddlewaresController } from '@portals/fetch-api';
import { loginMiddleware } from './login-middleware';
import { loginSeparateDomainMiddleware } from './login-separate-domain-middleware';

export const initRequestProxyVerify = () => {
  new MiddlewaresController().setMiddleware({
    middleware: loginMiddleware,
    name: '@root/loginMiddleware',
  });
  new MiddlewaresController().setMiddleware({
    middleware: loginSeparateDomainMiddleware,
    name: '@root/loginMiddlewareSeparateDomain',
  });
};
